<template>
   <div>
       <HeadDetailsGama :titleHead="'Detalhe consulta de comissões'"></HeadDetailsGama>
              <Tables ref="tableGridParcela"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showHeader="false"
              :showPaging="false"
              :showDownload="false"
              :showFullscreen="false"
              :showClickToSelect="false"
              v-on:Load="onLoad"
            >
              <tr v-for="parcela in consultaparcela" v-bind:key="parcela.id">
                <TableColumn :IsText="true"    :status="1" :value="parcela.valorParcelaFormatada"/>
                <TableColumn :IsText="true"    :status="1" :value="parcela.dataVencimentoFormatada" />
                <TableColumn :newState="true"  :newStatusNumber="parcela.status" :descriptionNewStatus="['Quitado','Vencido', 'A Receber'][parcela.status]" />
              </tr>
            </Tables>
   </div>
</template>

<script>
import Commissionform from './commissionform'
export default Commissionform
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/commissionform/commissionform.vue